import React, { Component } from "react";
import LabelWithText from "../../../components/molecules/LabelWithText";
import Label from "../../../components/atoms/Label";
import curencyFormat from "../../../utils/helpers/curencyFormat";

export default ({ title, dataDetail, setFromParam }) => {
	let col = { label: "col-md-3", text: "col-md-9" };
	let { corporate } = dataDetail.customerInfo;
	// console.log('====================================');
	// console.log({ dataDetail });
	// console.log('====================================');
	return (
		<div>
			<div className="container-title">
				<Label value={title} className="label-menu" />
			</div>
			<div>
				<LabelWithText label={"Alias"} text={corporate.nickname || "-"} col={col} />
				<LabelWithText label={"Tipe Perusahaan"} text={corporate.companyType ? setFromParam("companyType", corporate.companyType) : "-"} col={col} />
				<LabelWithText label={"Nama Perusahaan"} text={corporate.companyName || "-"} col={col} />
				<LabelWithText label={"Kategori Usaha"} text={corporate.companyBusinessType ? setFromParam("fieldOfWork", corporate.companyBusinessType) : "-"} col={col} />
				<LabelWithText label={"Berdiri Sejak (Tahun)"} text={corporate.companySince || "-"} col={col} />
				<LabelWithText label={"Surel Perusahaan"} text={dataDetail.companyEmail || "-"} col={col} />
				<LabelWithText label={"No. Telp. Perusahaan"} text={dataDetail.companyPhone || "-"} col={col} />
				<LabelWithText label={"Alamat"} text={corporate.domicileInfo.address || "-"} col={col} />
				<LabelWithText label={"Provinsi"} text={corporate.domicileInfo.provinceName ? corporate.domicileInfo.provinceName : "-"} col={col} />
				<LabelWithText label={"Kota/ Kabupaten"} text={corporate.domicileInfo.cityName ? corporate.domicileInfo.cityName : "-"} col={col} />
				<LabelWithText label={"Kecamatan"} text={corporate.domicileInfo.subdistrictName ? corporate.domicileInfo.subdistrictName : "-"} col={col} />
				<LabelWithText label={"Kelurahan"} text={corporate.domicileInfo.addressKelName ? corporate.domicileInfo.addressKelName : "-"} col={col} />
				<LabelWithText label={"Kode Pos"} text={corporate.domicileInfo.postalCode ? corporate.domicileInfo.postalCode : "-"} col={col} />
				<LabelWithText label={"Negara"} text={corporate.domicileInfo.country ? corporate.domicileInfo.country : "-"} col={col} />
				<LabelWithText label={"Jumlah Karyawan"} text={corporate.companyNumberOfEmployee ? setFromParam("companyNumberOfEmployee", corporate.companyNumberOfEmployee) : "-"} col={col} />
				<LabelWithText label={"Omzet per Bulan"} text={corporate.companyNumberOfEmployee ? setFromParam("monthlyIncome", corporate.companyMonthlyIncome) : "-"} col={col} />
				<LabelWithText label={"Jumlah Aset"} text={`Rp ${curencyFormat(dataDetail.companyAssetAmount)}`} col={col} />
				<LabelWithText label={"Deskripsi Perusahaan "} text={corporate.companyDescription || "-"} col={col} />
			</div>
		</div>
	);
};
